import { render, staticRenderFns } from "./ForwardMessageModal.vue?vue&type=template&id=509b7f43&"
import script from "./ForwardMessageModal.vue?vue&type=script&lang=js&"
export * from "./ForwardMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports